'use client';

import React from 'react';

import Link from 'next/link';

import Button from '@/components/FormFields/Button';
import { HeadingTwo } from '@/components/Typography/Heading';
import Paragraph from '@/components/Typography/Paragraph';
import useWebAlias from '@/helpers/hooks/useWebalias';

const SectionGreen = () => {
  const { webalias, generateURL } = useWebAlias();
  return (
    <div className="lg:py-auto relative flex flex-col items-center justify-center bg-primary bg-cover bg-center bg-no-repeat text-center sm:h-auto sm:py-[70px] sm:px-[30px] lg:h-[19.5rem] lg:px-0">
      <HeadingTwo className="mb-[18px] font-circular-std-medium" variant="light">
        Ready to take control of your pet&apos;s health?
      </HeadingTwo>
      <Paragraph className="mb-[26px] sm:px-1 lg:px-0" variant="light">
        It&apos;s time to bring love home with pawTree, so you can get back to creating memories!
      </Paragraph>
      <Link href={generateURL('/products', webalias)}>
        <Button
          type="button"
          className="w-[12.5rem] py-[5px] text-[1rem] leading-5"
          variant="outlined"
          scheme="primary"
        >
          Get Started!
        </Button>
      </Link>
    </div>
  );
};

export default SectionGreen;
